import React from 'react';
import { Table, ScrollBar } from '@unimed-fesp/components';

import FadeIn from '../../atoms/FadeIn';
import TableBeneficiarioBody from './TableBeneficiarioBody';
import TableBeneficiarioHeader from './TableBeneficiarioHeader';

function TabelaPesquisaBeneficiario({
  selectedBeneficiario,
  handleCheckBeneficiario,

  paginationParams,
  handleChangePage,
  setPaginationParams,
  handlePageChangeKeyDown,
}) {
  return (
    <ScrollBar height={320} width={880} style={{ marginTop: '15px' }}>
      <FadeIn>
        <Table head={<TableBeneficiarioHeader />}>
          <TableBeneficiarioBody
            selectedBeneficiario={selectedBeneficiario}
            handleCheckBeneficiario={handleCheckBeneficiario}
            paginationParams={paginationParams}
            setPaginationParams={setPaginationParams}
            handlePageChangeKeyDown={handlePageChangeKeyDown}
            callbackChangePage={handleChangePage}
          />
        </Table>
      </FadeIn>
    </ScrollBar>
  );
}

export default TabelaPesquisaBeneficiario;
